import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
export default React.memo(function Radio({ onChange, value, label = '', checked = false, selected, name, className = '' }) {
    const template = _jsxs(Container, { className: `${className} ui-radio`, children: [_jsx("input", { name: name, type: "radio", checked: checked || value !== undefined && selected === value, onChange: () => onChange(value) }), _jsx("span", {})] });
    if (label) {
        return (_jsxs(Label, { className: className, children: [template, _jsx(LabelSpan, { children: label })] }));
    }
    return template;
});
const Container = styled.span `
    position: relative;

    & > input[type=radio]{
        display: none;

        & + span {
            display: block;
            width: 1.25rem;
            height: 1.25rem;
            box-sizing: border-box;
            background: var(--ui-input-background);
            border: 1px solid var(--ui-input-border-color);
            border-radius: 50%;
        }

        &:hover + span {
            border: 1px solid var(--ui-input-border-hover);
        }

        &:checked + span {
            background: var(--ui-color-white);
            border: 0.4rem solid var(--ui-accent-color);
        }
    }
`;
const Label = styled.label `
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;    
`;
const LabelSpan = styled.span `
    display: flex;
    margin-bottom: 1px;
    margin-left: 0.5em;
    user-select: none;
    
    font-size: 0.875rem;
    line-height: 1rem;
    font-weight: 500;
    color: var(--text-primary);
`;
